import http from "./httpService.ts";

export const UPLOAD_LIFECYCLE_STAGES = [
  "started",
  "blob_completed",
  "failed",
] as const;

export type UploadLifecycleStage = (typeof UPLOAD_LIFECYCLE_STAGES)[number];

export type UploadLifecycleRequest = {
  readonly uploadId: string;
  readonly lifecycleStage: UploadLifecycleStage;
};

const TELEMETRY_TIMEOUT_MS = 1_500;

export const reportUploadLifecycle = async (
  request: UploadLifecycleRequest,
): Promise<void> => {
  await http.post("/api/v1/projects/lite/upload-lifecycle", request, {
    timeout: TELEMETRY_TIMEOUT_MS,
  });
};
